module.exports = __webpack_public_path__ + "static/media/tick.feba6e50.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/tick.jpg
// module id = 62
// module chunks = 0